'use client'

import Image from 'next/image'
import useAddToHomescreenPrompt from './use-add-to-home-screen'
import A2hsShimmer from '../desktop/a2hs-button/shimmer'
import s from '../../style.module.scss'
import {HeaderEvent} from '../../analytics/events'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import clsx from 'clsx'

const A2hsButtonClient = () => {
  const {promptToInstall, showA2HS} = useAddToHomescreenPrompt()

  return (
    <div
      className={clsx(s.a2hs_container, {
        '!hidden': showA2HS === false,
      })}
    >
      {showA2HS === undefined && <A2hsShimmer css={s.shimmer} />}
      {showA2HS && (
        <button
          onClick={() => {
            promptToInstall()
            triggerAnalytics(HeaderEvent.A2HSButtonClicked).sendAll()
          }}
          className={s.a2hs_download_btn}
        >
          <Image
            src='https://static.gamezop.com/comet/assets/img2/download-btn-blue.svg'
            alt='add to home screen button'
            width={20}
            height={20}
          />
        </button>
      )}
    </div>
  )
}

export default A2hsButtonClient
